import { useState } from "react";
import { Trash2, AlertTriangle, X } from "lucide-react";
import "./settings.css";
export default function AccountSettings() {
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleDeleteAccount = async () => {
    // Connect your delete-account API here later.
    // Example:
    // await API.delete("/users/account");

    console.log("Delete account requested");

    setShowDeleteModal(false);
  };

  return (
    <>
      <section className="settings-card danger">
        <div className="card-header">
          <h3>Account</h3>
          <p>Manage your account status</p>
        </div>

        <div className="card-row account-danger-row">
          <div className="account-danger-content">
            <div className="account-danger-title">
              <Trash2 size={18} />
              <strong>Delete account</strong>
            </div>

            <p className="muted">
              Permanently remove your Civilink account
              and all associated data.
            </p>
          </div>

          <button
            type="button"
            className="btn-danger"
            onClick={() => setShowDeleteModal(true)}
          >
            Delete
          </button>
        </div>
      </section>

      {/* DELETE CONFIRMATION */}
      {showDeleteModal && (
        <div
          className="delete-modal-overlay"
          onClick={() => setShowDeleteModal(false)}
        >
          <div
            className="delete-modal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="delete-account-title"
          >
            <button
              type="button"
              className="delete-modal-close"
              onClick={() => setShowDeleteModal(false)}
              aria-label="Close"
            >
              <X size={19} />
            </button>

            <div className="delete-warning-icon">
              <AlertTriangle size={24} />
            </div>

            <h3 id="delete-account-title">
              Delete your account?
            </h3>

            <p>
              This action will permanently remove your
              Civilink account and associated data.
            </p>

            <div className="delete-modal-actions">
              <button
                type="button"
                className="delete-cancel-btn"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>

              <button
                type="button"
                className="delete-confirm-btn"
                onClick={handleDeleteAccount}
              >
                Delete Account
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}